import { useEffect,  useState } from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from 'react-hook-form';
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, TextField, Chip } from '@mui/material';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentCategoriesByQuery, postEquipmentCategories, patchEquipmentCategories, deleteEquipmentCategories } from 'components/axios/equipmentCategoryAxios';
import { deleteEquipmentStatusBasicItems, deleteEquipmentStatusItems, getEquipmentStatusBasicItemsByQuery, getEquipmentStatusItemsByQuery, patchEquipmentStatusBasicItems, patchEquipmentStatusItems, postEquipmentStatusBasicItems, postEquipmentStatusItems } from 'components/axios/equipmentStatusItemsAxios';
import MainCard from 'components/MainCard';
import { useQueryClient } from '@tanstack/react-query';

const EquipmentStatusStandardSetting = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
    openModal(modals.alertModal, {
      onClose : () => {
      },
      message: alertMessage,
     });
  };

  const { register : level1Register, handleSubmit : level1HandleSubmit, reset : level1Reset
    , formState : {isDirty : level1IsDirty, errors : level1Errors } } = useForm({});
  const { register : level1UpdateRegister, handleSubmit : level1UpdateHandleSubmit, reset : level1UpdateReset
    , formState : {isDirty : level1UpdateIsDirty, errors : level1UpdateErrors } } = useForm({});
    
  const { register : level2Register, handleSubmit : level2HandleSubmit, reset : level2Reset
    , formState : {isDirty : level2IsDirty, errors : level2Errors } } = useForm({});
  const { register : level2UpdateRegister, handleSubmit : level2UpdateHandleSubmit, reset : level2UpdateReset
    , formState : {isDirty : level2UpdateIsDirty, errors : level2UpdateErrors } } = useForm({});

  const { register : level3Register, handleSubmit : level3HandleSubmit, reset : level3Reset
    , formState : {isDirty : level3IsDirty, errors : level3Errors } } = useForm({});
  const { register : level3UpdateRegister, handleSubmit : level3UpdateHandleSubmit, reset : level3UpdateReset
    , formState : {isDirty : level3UpdateIsDirty, errors : level3UpdateErrors } } = useForm({});
  
  const { register : basicItemsRegister, handleSubmit : basicItemsHandleSubmit, reset : basicItemsReset
    , formState : {isDirty : basicItemsIsDirty, errors : basicItemsErrors } } = useForm({});
  const { register : basicItemsUpdateRegister, handleSubmit : basicItemsUpdateHandleSubmit, reset : basicItemsUpdateReset
    , formState : {isDirty : basicItemsUpdateIsDirty, errors : basicItemsUpdateErrors } } = useForm({});

  const { register : itemsRegister, handleSubmit : itemsHandleSubmit, reset : itemsReset
    , formState : {isDirty : itemsIsDirty, errors : itemsErrors } } = useForm({});
  const { register : itemsUpdateRegister, handleSubmit : itemsUpdateHandleSubmit, reset : itemsUpdateReset
    , formState : {isDirty : itemsUpdateIsDirty, errors : itemsUpdateErrors } } = useForm({});
  
  const [isLoading, setIsLoading] = useState(false);
  
  const [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  const [equipmentStatusBasicItems, setEquipmentStatusBasicItems] = useState([]);
  const [equipmentStatusItems, setEquipmentStatusItems] = useState([]);

  let [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState(0);
  let [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState(0);
  let [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState(0);

  const [equipmentCategoryLevel1sSelected, setEquipmentCategoryLevel1sSelected] = useState([]);
  const [equipmentCategoryLevel2sSelected, setEquipmentCategoryLevel2sSelected] = useState([]);
  const [equipmentCategoryLevel3sSelected, setEquipmentCategoryLevel3sSelected] = useState([]);

  const [equipmentCategoryLevel1sModifyView, setEquipmentCategoryLevel1sModifyView] = useState([]);
  const [equipmentCategoryLevel2sModifyView, setEquipmentCategoryLevel2sModifyView] = useState([]);
  const [equipmentCategoryLevel3sModifyView, setEquipmentCategoryLevel3sModifyView] = useState([]);
  const [equipmentStatusBasicItemsModifyView, setEquipmentStatusBasicItemsModifyView] = useState([]);
  const [equipmentStatusItemsModifyView, setEquipmentStatusItemsModifyView] = useState([]);

  let separate = "___";
   
  useEffect(()=> {
    equipmentCategoryLevel1List();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  
  // 설비대분류 목록
  const equipmentCategoryLevel1List = async () => {
    const param = { depth: 1, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel1s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel1sModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel1sSelected(arr2);
          selectEquipmentCategoryLevel1(0, list[0]);
        } else {
          setEquipmentCategoryLevel1s([]);
          setEquipmentCategoryLevel1sModifyView([]);
          equipmentCategoryLevel2List();
        }
      } else {
        setEquipmentCategoryLevel1s([]);
        setEquipmentCategoryLevel1sModifyView([]);
        equipmentCategoryLevel2List();
        setEquipmentCategoryLevel2Id(0);
        setEquipmentCategoryLevel3Id(0);
      }
    });
  };

  // 설비대분류 선택
  const selectEquipmentCategoryLevel1 = (i, data) => {
    equipmentCategoryLevel1Id = data.id;
    equipmentCategoryLevel2Id = 0;
    equipmentCategoryLevel3Id = 0;
    setEquipmentCategoryLevel1Id(data.id);
    setEquipmentCategoryLevel2Id(0);
    setEquipmentCategoryLevel3Id(0);
    setEquipmentStatusBasicItems([]);
    let copy = [...equipmentCategoryLevel1sSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "select_active";
    setEquipmentCategoryLevel1sSelected(copy);
    equipmentCategoryLevel2List();
  };

  // 설비대분류등록
  let onSubmitLevel1 = (data) => {
    const level1Name = data.level1Name;
    const level1Code = data.level1Code;

    console.log('level1 write');
    console.log("level1Name : " + level1Name);
    console.log("level1Code : " + level1Code);

    let body = {
      id: null,
      code : level1Code,
      name: level1Name,
      depth: 1
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
      },
      message: t('message.common.alert.write.question'),
    });
    level1Reset();
  };

  // 설비대분류수정
  let onSubmitLevel1Update = (data) => {
    const level1Id = data.level1Id;
    const level1Name = data.level1NameUpdate;
    const level1Code = data.level1CodeUpdate;

    console.log('level1 modify');
    console.log("level1Id : " + level1Id);
    console.log("level1Name : " + level1Name);
    console.log("level1Code : " + level1Code);

    let body = {
      id: level1Id,
      code: level1Code,
      name: level1Name
    };
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
       //   console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비대분류 삭제
  const handleEquipmentCategoryLevel1DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          setEquipmentCategoryLevel1Id(0);
          setEquipmentCategoryLevel2Id(0);
          setEquipmentCategoryLevel3Id(0);
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level1Reset();
      },
      onClose: () => {
       // console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 설비중분류 목록
  const equipmentCategoryLevel2List = async () => {
    const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel2s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel2sModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel2sSelected(arr2);
          selectEquipmentCategoryLevel2(0, list[0]);
        } else {
          setEquipmentCategoryLevel2s([]);
          setEquipmentCategoryLevel2sModifyView([]);
          equipmentCategoryLevel3List();
        }
      } else {
        setEquipmentCategoryLevel2s([]);
        setEquipmentCategoryLevel2sModifyView([]);
        equipmentCategoryLevel3List();
        setEquipmentCategoryLevel3Id(0);
      }
    });
  };

  // 설비중분류 선택
  const selectEquipmentCategoryLevel2 = async(i, data) => {
      equipmentCategoryLevel2Id = data.id;
      equipmentCategoryLevel3Id = 0;
      setEquipmentCategoryLevel2Id(data.id);
      setEquipmentCategoryLevel3Id(0);
      setEquipmentStatusBasicItems([]);
      let copy = [...equipmentCategoryLevel2sSelected];
      copy = Array.from({ length: copy.length }, () => null);
      copy[i] = "select_active";
      setEquipmentCategoryLevel2sSelected(copy);
      equipmentCategoryLevel3List();
  };

  // 설비중분류등록
  let onSubmitLevel2 = (data) => {
    const level2Name = data.level2Name;

    let body = {
      parent: {
        id: equipmentCategoryLevel1Id
      },
      //      id : null,
      name: level2Name,
      depth: 2
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level2Reset();
  };

  // 설비중분류수정
  let onSubmitLevel2Update = (data) => {
    const level2Id = data.level2Id;
    const level2Name = data.level2NameUpdate;

    let body = {
      id: level2Id,
      name: level2Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비중분류 삭제
  const handleEquipmentCategoryLevel2DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel2List();
          setEquipmentCategoryLevel2Id(0);
          setEquipmentCategoryLevel3Id(0);
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level2Reset();
      },
      onClose: () => {
       // console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 설비분류 목록
  const equipmentCategoryLevel3List = async () => {
    const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel3s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel3sModifyView(arr);

          let arr3 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel3sSelected(arr3);
          selectEquipmentCategoryLevel3(0, list[0]);
        } else {
          setEquipmentCategoryLevel3s([]);
          setEquipmentCategoryLevel3sModifyView([]);
          equipmentStatusBasicItemsList();
          equipmentStatusItemsList();
        }
      } else {
        setEquipmentCategoryLevel3s([]);
        setEquipmentCategoryLevel3sModifyView([]);
        equipmentStatusBasicItemsList();
        equipmentStatusItemsList();
      }
    });
  };

  // 설비분류 선택
  const selectEquipmentCategoryLevel3 = async(i, data) => {

    equipmentCategoryLevel3Id = data.id;
    setEquipmentCategoryLevel3Id(data.id);
  
    let copy = [...equipmentCategoryLevel3sSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "select_active";
    setEquipmentCategoryLevel3sSelected(copy);
    equipmentStatusBasicItemsList();
    equipmentStatusItemsList();
  };

  // 설비분류등록
  let onSubmitLevel3 = (data) => {
    const level3Name = data.level3Name;
    const level3Code = data.level3Code;

    let body = {
      parent: {
        id: equipmentCategoryLevel2Id
      },
      //      id : null,
      code: level3Code,
      name: level3Name,
      depth: 3
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel3List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
       //   console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level3Reset();
  };

  // 설비분류수정
  let onSubmitLevel3Update = (data) => {
    const level3Id = data.level3Id;
    const level3Name = data.level3NameUpdate;
    const level3Code = data.level3CodeUpdate;

    let body = {
      id: level3Id,
      code: level3Code,
      name: level3Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel3List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비분류 삭제
  const handleEquipmentCategoryLevel3DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel3List();
          setEquipmentCategoryLevel3Id(0); 
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level3Reset();
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };
  
  // 설비현황기준관리(기본현황) 목록
  const equipmentStatusBasicItemsList = async () => {
    const param = { "equipmentCtgr.id": equipmentCategoryLevel3Id, size : 100, sort : "id,asc"};
    await getEquipmentStatusBasicItemsByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentStatusBasicItems;
        if (list) {
          setEquipmentStatusBasicItems(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentStatusBasicItemsModifyView(arr);
        } else {
          setEquipmentStatusBasicItems([]);
          setEquipmentStatusBasicItemsModifyView([]);
        }
      } else {
        setEquipmentStatusBasicItems([]);
        setEquipmentStatusBasicItemsModifyView([]);
      }
    });
    setIsLoading(true);
  };

  // 설비현황기준관리(기본현황) 등록
  let onSubmitStatusBasicItems = (data) => {
    const itemNm = data.itemNm;
    const value = data.value;
    const equipmentCtgrId = equipmentCategoryLevel3Id;

    let body = {
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      itemNm,
      value
    };

  openModal(modals.confirmModal, {
    onSubmit : (value) => {
      postEquipmentStatusBasicItems(body).then((res)=>{
          equipmentStatusBasicItemsList();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
         // console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    basicItemsReset();
  };

  // 설비현황기준관리(기본현황) 수정
  let onSubmitStatusBasicItemsUpdate = (data) => {
    const id = data.basicItemsIdUpdate;
    const itemNm = data.itemNmUpdate;
    const value = data.valueUpdate;
    const equipmentCtgrId = equipmentCategoryLevel3Id;

    let body = {
      id,
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      itemNm,
      value
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentStatusBasicItems(body).then((res)=>{
          equipmentStatusBasicItemsList();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비현황기준관리(기본현황) 삭제
  const handleStatusBasicItemsDeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentStatusBasicItems(param).then((res) => {
          equipmentStatusBasicItemsList();
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose: () => {
       // console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
    basicItemsReset();
  };

  // 설비현황기준관리(성능현황) 목록
  const equipmentStatusItemsList = async () => {
    const param = { "equipmentCtgr.id": equipmentCategoryLevel3Id, size : 100, sort : "id,asc"};
    await getEquipmentStatusItemsByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentStatusItems;
        if (list) {
          setEquipmentStatusItems(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentStatusItemsModifyView(arr);
        } else {
          setEquipmentStatusItems([]);
          setEquipmentStatusItemsModifyView([]);
        }
      } else {
        setEquipmentStatusItems([]);
        setEquipmentStatusItemsModifyView([]);
      }
    });
  };

  // 설비현황기준관리(성능현황) 등록
  let onSubmitStatusItems = (data) => {
    let itemNm = data.itemNm;
    const unit = data.unit;
    const value = data.value;
    const equipmentCtgrId = equipmentCategoryLevel3Id;
    let level1 = data.level1;
    let level2 = data.level2;

    if (!level1 && level2) {
      level1 = level2;
      level2 = '';
    }

    itemNm = level1 + separate + level2 + separate + itemNm;

    let body = {
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      itemNm,
      unit,
      value
    };

  openModal(modals.confirmModal, {
    onSubmit : (value) => {
      postEquipmentStatusItems(body).then((res)=>{
          equipmentStatusItemsList();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    itemsReset();
  };

  // 설비현황기준관리(성능현황) 수정
  let onSubmitStatusItemsUpdate = (data) => {
    const id = data.itemsIdUpdate;
    let itemNm = data.itemNmUpdate;
    const unit = data.unitUpdate;
    const value = data.valueUpdate;
    const equipmentCtgrId = equipmentCategoryLevel3Id;
    let level1 = data.level1Update;
    let level2 = data.level2Update;

    if (!level1 && level2) {
      level1 = level2;
      level2 = '';
    }

    itemNm = level1 + separate + level2 + separate + itemNm;

    let body = {
      id,
      equipmentCtgr: {
        id: equipmentCtgrId
      },
      itemNm,
      unit,
      value
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentStatusItems(body).then((res)=>{
          equipmentStatusItemsList();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        }); 
      },
      onClose : () => {
        //  console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비현황기준관리(성능현황) 삭제
  const handleStatusItemsDeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentStatusItems(param).then((res) => {
          equipmentStatusItemsList();
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose: () => {
       // console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
    itemsReset();
  };

  if (isLoading) {
  return (
    <div className='cal'>
    <div className="scroll_table scroll_table1 scroll_table2" style={{padding:"15px 0"}}>
      <div>
        <TableContainer>
        <form onSubmit={level1HandleSubmit(onSubmitLevel1)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel1s && equipmentCategoryLevel1s.map(function(con, i) {
              if (equipmentCategoryLevel1sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level1UpdateRegister("level1Id")} value={equipmentCategoryLevel1s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level1UpdateIsDirty ? undefined : level1UpdateErrors.level1NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel1s[i].name} 
                    {...level1UpdateRegister("level1NameUpdate", {
                      required : t('message.common.error.text.level1.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level1UpdateErrors.level1NameUpdate && <small role="alert"><br></br>{level1UpdateErrors.level1NameUpdate.message}</small>}
                    <div style={{display: "flex",alignItems: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!level1UpdateIsDirty ? undefined : level1UpdateErrors.level1CodeUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel1s[i].code} 
                    {...level1UpdateRegister("level1CodeUpdate", {
                      // required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '100%' }} />)</div>
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level1UpdateHandleSubmit(onSubmitLevel1Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel1sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel1(i, equipmentCategoryLevel1s[i]);
                  }}>{equipmentCategoryLevel1s[i].name}<br/>{(equipmentCategoryLevel1s[i].code && '('+equipmentCategoryLevel1s[i].code+')') || ''}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel1DeleteBtnClick(equipmentCategoryLevel1s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>

            <tfoot>
              <tr>
                <td>
                  <div style={{marginBottom: "5px"}}>
                    <TextField id="outlined-basic" 
                    aria-invalid={!level1IsDirty ? undefined : level1Errors.level1Name ? "true" : "false"}
                    {...level1Register("level1Name", {
                      required : t('message.common.error.text.level1.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                  </div>
                  {level1Errors.level1Name && <small role="alert"><br></br>{level1Errors.level1Name.message}</small>}
                  
                  <div style={{display: "flex",alignItems: "center"}}>
                  (<TextField id="outlined-basic" 
                  // aria-invalid={!level1IsDirty ? undefined : level1Errors.level1Code ? "true" : "false"}
                  {...level1Register("level1Code", {
                    // required : t('message.common.error.text.levelCode.input')
                  })} 
                  sx={{ minWidth: '90%' }} />)</div>
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level1HandleSubmit(onSubmitLevel1)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
          </Table>
        </form>
        </TableContainer>

        <TableContainer>
        <form onSubmit={level2HandleSubmit(onSubmitLevel2)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}<br/>&nbsp;</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel2s && equipmentCategoryLevel2s.map(function(con, i) {
              if (equipmentCategoryLevel2sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level2UpdateRegister("level2Id")} value={equipmentCategoryLevel2s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level2UpdateIsDirty ? undefined : level2UpdateErrors.level2NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel2s[i].name} 
                    {...level2UpdateRegister("level2NameUpdate", {
                      required : t('message.common.error.text.level2.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level2UpdateErrors.level2NameUpdate && <small role="alert"><br></br>{level2UpdateErrors.level2NameUpdate.message}</small>}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level2UpdateHandleSubmit(onSubmitLevel2Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel2sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel2(i, equipmentCategoryLevel2s[i]);
                  }}>{equipmentCategoryLevel2s[i].name}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel2DeleteBtnClick(equipmentCategoryLevel2s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>
            {(equipmentCategoryLevel1Id || '') &&
            <tfoot>
              <tr>
                <td>
                  <TextField id="outlined-basic" 
                  aria-invalid={!level2IsDirty ? undefined : level2Errors.level2Name ? "true" : "false"}
                  {...level2Register("level2Name", {
                    required : t('message.common.error.text.level2.input')
                  })} 
                  sx={{ minWidth: '100%' }} />
                  {level2Errors.level2Name && <small role="alert"><br></br>{level2Errors.level2Name.message}</small>}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level2HandleSubmit(onSubmitLevel2)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
            }
          </Table>
          </form>
        </TableContainer>

        <TableContainer>
        <form onSubmit={level3HandleSubmit(onSubmitLevel3)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel3s && equipmentCategoryLevel3s.map(function(con, i) {
              if (equipmentCategoryLevel3sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level3UpdateRegister("level3Id")} value={equipmentCategoryLevel3s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level3UpdateIsDirty ? undefined : level3UpdateErrors.level3NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel3s[i].name} 
                    {...level3UpdateRegister("level3NameUpdate", {
                      required : t('message.common.error.text.level3.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level3UpdateErrors.level3NameUpdate && <small role="alert"><br></br>{level3UpdateErrors.level3NameUpdate.message}</small>}
                    <div style={{display: "flex",alignItems: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!level3UpdateIsDirty ? undefined : level3UpdateErrors.level3CodeUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel3s[i].code} 
                    {...level3UpdateRegister("level3CodeUpdate", {
                      // required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '100%' }} />)</div>
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level3UpdateHandleSubmit(onSubmitLevel3Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel3s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel3sModifyView(arr);
                    level3UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel3sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel3(i, equipmentCategoryLevel3s[i]);
                  }}>{equipmentCategoryLevel3s[i].name}<br/>{(equipmentCategoryLevel3s[i].code && '('+equipmentCategoryLevel3s[i].code+')') || ''}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel3s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel3sModifyView(arr);
                    level3UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel3DeleteBtnClick(equipmentCategoryLevel3s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>
            {(equipmentCategoryLevel2Id || '') &&
            <tfoot>
              <tr>
                <td>
                  <TextField id="outlined-basic" 
                  aria-invalid={!level3IsDirty ? undefined : level3Errors.level3Name ? "true" : "false"}
                  {...level3Register("level3Name", {
                    required : t('message.common.error.text.level3.input')
                  })} 
                  sx={{ minWidth: '100%' }} />
                  {level3Errors.level3Name && <small role="alert"><br></br>{level3Errors.level3Name.message}</small>}

                  <div style={{display: "flex",alignItems: "center"}}>
                  (<TextField id="outlined-basic" 
                  {...level3Register("level3Code", {
                  })} 
                  sx={{ minWidth: '90%' }} />)</div>

                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level3HandleSubmit(onSubmitLevel3)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
            }
          </Table>
          </form>
        </TableContainer>
      </div>

      <div>
        <div style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}>
          <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
          <Chip label={t('message.common.chip.basic.status.information')} className="setup_chip" />
        </div>

        <div>
        <MainCard style={{marginTop:"10px"}}>
          <form onSubmit={basicItemsHandleSubmit(onSubmitStatusBasicItems)}>
          <TableContainer>              
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="th" align="center">{t('message.common.subtitle.item')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.basic.value')}</TableCell>
                  <TableCell className="th" align="center"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
              { equipmentStatusBasicItems && equipmentStatusBasicItems.map(function(con, i) {
              if (equipmentStatusBasicItemsModifyView[i]) {  // 수정폼
                return (
                <TableRow key={con.id}>
                  <TableCell>
                    <input type="hidden" {...basicItemsUpdateRegister("basicItemsIdUpdate")} value={equipmentStatusBasicItems[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!basicItemsUpdateIsDirty ? undefined : basicItemsUpdateErrors.itemNmUpdate ? "true" : "false"}
                    defaultValue={equipmentStatusBasicItems[i].itemNm} 
                    {...basicItemsUpdateRegister("itemNmUpdate", {
                      required : t('message.common.error.text.item.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {basicItemsUpdateErrors.itemNmUpdate && <small role="alert"><br></br>{basicItemsUpdateErrors.itemNmUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    defaultValue={equipmentStatusBasicItems[i].value} 
                    {...basicItemsUpdateRegister("valueUpdate", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" 
                      onClick={basicItemsUpdateHandleSubmit(onSubmitStatusBasicItemsUpdate)}
                    >{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentStatusBasicItems.length},() => false);
                      arr[i] = false;
                      setEquipmentStatusBasicItemsModifyView(arr);
                      basicItemsUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                  )
              } else {  // 목록
                return (
                <TableRow key={con.id}>
                  <TableCell>{equipmentStatusBasicItems[i].itemNm}</TableCell>
                  <TableCell>{equipmentStatusBasicItems[i].value}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentStatusBasicItems.length},() => false);
                      arr[i] = true;
                      setEquipmentStatusBasicItemsModifyView(arr);
                      basicItemsUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleStatusBasicItemsDeleteBtnClick(equipmentStatusBasicItems[i].id);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                </TableRow>
                  )
                }
              }) }
              </TableBody>
              {(equipmentCategoryLevel3Id || '') &&
              <tfoot>
                <tr>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    aria-invalid={!basicItemsIsDirty ? undefined : basicItemsErrors.itemNm ? "true" : "false"}
                    defaultValue={''} 
                    {...basicItemsRegister("itemNm", {
                      required : t('message.common.error.text.item.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {basicItemsErrors.itemNm && <small role="alert"><br></br>{basicItemsErrors.itemNm.message}</small>}
                  </td>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    defaultValue={''} 
                    {...basicItemsRegister("value", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </td>
                  <td>
                    <Button variant="contained" color="primary" onClick={basicItemsHandleSubmit(onSubmitStatusBasicItems)}>{t('message.common.btn.add')}</Button>
                  </td>
                </tr>
              </tfoot>
              }
            </Table>
          </TableContainer>
          </form>
          </MainCard>
        </div>
  
        <div style={{margin:"10px 0"}}></div>

        <div style={{display:"flex", justifyContent: "flex-start", alignItems:"center"}}>
          <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
          <Chip label={t('message.common.chip.performance.status.information')} className="setup_chip" />
        </div>

        <div>
        <MainCard style={{marginTop:"10px"}}>
          <form onSubmit={itemsHandleSubmit(onSubmitStatusItems)}>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="th" align="center">{t('message.common.subtitle.category.one')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.category.two')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.item.name')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.unit')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.basic.value')}</TableCell>
                  <TableCell className="th" align="center"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
              { equipmentStatusItems && equipmentStatusItems.map(function(con, i) {
                let itemName = equipmentStatusItems[i].itemNm.split(separate);
              if (equipmentStatusItemsModifyView[i]) {  // 수정폼
                return (
                <TableRow key={con.id}>
                  <TableCell>
                    <input type="hidden" {...itemsUpdateRegister("itemsIdUpdate")} value={equipmentStatusItems[i].id} />
                    <TextField id="outlined-basic" 
                    defaultValue={itemName[0]} 
                     {...itemsUpdateRegister("level1Update", {
                     })} 
                    sx={{ minWidth: '90%' }} />
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    defaultValue={itemName[1]} 
                    {...itemsUpdateRegister("level2Update", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    aria-invalid={!itemsUpdateIsDirty ? undefined : itemsUpdateErrors.itemNmUpdate ? "true" : "false"}
                    defaultValue={itemName[2]} 
                    {...itemsUpdateRegister("itemNmUpdate", {
                      required : t('message.common.error.text.item.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {itemsUpdateErrors.itemNmUpdate && <small role="alert"><br></br>{itemsUpdateErrors.itemNmUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    aria-invalid={!itemsUpdateIsDirty ? undefined : itemsUpdateErrors.unitUpdate ? "true" : "false"}
                    defaultValue={equipmentStatusItems[i].unit} 
                    {...itemsUpdateRegister("unitUpdate", {
                      required : t('message.common.error.text.unit.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {itemsUpdateErrors.unitUpdate && <small role="alert"><br></br>{itemsUpdateErrors.unitUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                    <TextField id="outlined-basic" 
                    defaultValue={equipmentStatusItems[i].value} 
                    {...itemsUpdateRegister("valueUpdate", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" 
                      onClick={itemsUpdateHandleSubmit(onSubmitStatusItemsUpdate)}
                    >{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentStatusItems.length},() => false);
                      arr[i] = false;
                      setEquipmentStatusItemsModifyView(arr);
                      itemsUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                  )
              } else {  // 목록
                return (
                <TableRow key={con.id}>
                  <TableCell>{itemName[0]}</TableCell>
                  <TableCell>{itemName[1]}</TableCell>
                  <TableCell>{itemName[2]}</TableCell>
                  <TableCell>{equipmentStatusItems[i].unit}</TableCell>
                  <TableCell>{equipmentStatusItems[i].value}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentStatusItems.length},() => false);
                      arr[i] = true;
                      setEquipmentStatusItemsModifyView(arr);
                      itemsUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleStatusItemsDeleteBtnClick(equipmentStatusItems[i].id);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                  </TableRow>
                  )
                }
              }) }
              </TableBody>
              {(equipmentCategoryLevel3Id || '') &&
              <tfoot>
                <tr>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    {...itemsRegister("level1", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </td>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    {...itemsRegister("level2", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </td>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    aria-invalid={!itemsIsDirty ? undefined : itemsErrors.itemNm ? "true" : "false"}
                    defaultValue={''} 
                    {...itemsRegister("itemNm", {
                      required : t('message.common.error.text.item.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {itemsErrors.itemNm && <small role="alert"><br></br>{itemsErrors.itemNm.message}</small>}
                  </td>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    aria-invalid={!itemsIsDirty ? undefined : itemsErrors.unit ? "true" : "false"}
                    defaultValue={''} 
                    {...itemsRegister("unit", {
                      required : t('message.common.error.text.unit.input')
                    })} 
                    sx={{ minWidth: '90%' }} />
                    {itemsErrors.unit && <small role="alert"><br></br>{itemsErrors.unit.message}</small>}
                  </td>
                  <td className="field">
                    <TextField id="outlined-basic" 
                    defaultValue={''} 
                    {...itemsRegister("value", {
                    })} 
                    sx={{ minWidth: '90%' }} />
                  </td>
                  <td><Button variant="contained" color="primary" onClick={itemsHandleSubmit(onSubmitStatusItems)}>{t('message.common.btn.add')}</Button></td>
                </tr>
              </tfoot>
              }
            </Table>
          </TableContainer>
          </form>
          </MainCard>
        </div>
      </div>
    </div>
    </div>
  );
}
}
 
export default EquipmentStatusStandardSetting;
